const languages: { [key: string]: string } = {
  BR: 'pt-BR',
  AR: 'es-AR',
  CO: 'es-CO',
  MX: 'es-MX',
};

const documentTypes: { [key: string]: string } = {
  BR: 'CNPJ',
  AR: 'CUIT',
  CO: 'NIT',
  MX: 'RFC',
};

export const getLanguageById = (id: string): string => languages[id];

export const getDocumentTypeById = (id: string): string => documentTypes[id];

export const getLanguageWithoutRegion = (language: string) => language.split('-')[0];
export const getLanguageRegion = (language: string) => language.split('-')[1];
